import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

function CareersPage() {
  const { t } = useTranslation();

  return (
    <div
      className="careers-page"
      style={{ padding: "4rem 2rem", maxWidth: "1100px", margin: "0 auto" }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "1rem" }}>
        {t("careers.title")}
      </h1>
      <p
        style={{
          textAlign: "center",
          marginBottom: "2rem",
          fontSize: "1.1rem",
        }}
      >
        {t("careers.intro")}
      </p>

      <div style={{ display: "grid", gap: "1.5rem" }}>
        <div
          style={{
            padding: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <h2>{t("careers.jobs.developer.title")}</h2>
          <p>{t("careers.jobs.developer.description")}</p>
        </div>

        <div
          style={{
            padding: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <h2>{t("careers.jobs.marketing.title")}</h2>
          <p>{t("careers.jobs.marketing.description")}</p>
        </div>

        <div
          style={{
            padding: "1.5rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <h2>{t("careers.jobs.support.title")}</h2>
          <p>{t("careers.jobs.support.description")}</p>
        </div>
      </div>
    </div>
  );
}

export default CareersPage;
